class ObservacionItem {
    constructor(idObservacion,fechaIngreso,fechaIngresoFormateada,descripcionObservacion,caratula,idJuicio,nroExpediente,nroSiniestro,apellidoTrabajador,nombreTrabajador,tipoProceso,estado,motivoRechazo){
      this.idObservacion=idObservacion
      this.fechaIngreso=fechaIngreso
      this.fechaIngresoFormateada=fechaIngresoFormateada
      this.descripcionObservacion=descripcionObservacion
      this.caratula=caratula
      this.idJuicio=idJuicio
      this.nroExpediente=nroExpediente
      this.nroSiniestro=nroSiniestro
      this.apellidoTrabajador=apellidoTrabajador
      this.nombreTrabajador=nombreTrabajador
      this.tipoProceso=tipoProceso
      this.estado=estado
      this.estado=estado
      this.motivoRechazo=motivoRechazo
    }
  }

  class Observacion {
    constructor(idObservacion,observacion,email){
      this.idObservacion=idObservacion
      this.observacion=observacion
      this.email=email
    }
  }
  
  export { ObservacionItem, Observacion }
  
